module.exports = __webpack_public_path__ + "sample.585c5adcced2a97dea90045cb9eb6311.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sample.jpg
// module id = 1155
// module chunks = 0